// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isAppsApiLimitsAppGroupRateLimitDatatableAppGroupIdResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      id: string,
      endpoints: arrayOf(string),
      rate_limit: objectOf({
        limit: number,
        period: number,
      }),
      type: string,
      last_changed_timestamp: string,
    })
  ),
});
